import { render, staticRenderFns } from "./shopConfigSms.vue?vue&type=template&id=215c424d&scoped=true"
import script from "./shopConfigSms.vue?vue&type=script&lang=js"
export * from "./shopConfigSms.vue?vue&type=script&lang=js"
import style0 from "./shopConfigSms.vue?vue&type=style&index=0&id=215c424d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c424d",
  null
  
)

export default component.exports